import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-none"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "mt-5 mb-2" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "mb-0 ml-3" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "mt-5 mb-2" }
const _hoisted_9 = { class: "p-field-radiobutton" }
const _hoisted_10 = { for: "LastStataus" }
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = { for: "Opened" }
const _hoisted_13 = { class: "p-field-radiobutton" }
const _hoisted_14 = { for: "Closed" }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "mt-5 mb-2" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "mb-0 ml-3" }
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "mt-5 mb-2" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "mb-0 ml-3" }
const _hoisted_23 = { class: "mt-5 mb-2" }
const _hoisted_24 = { key: 5 }
const _hoisted_25 = { class: "mt-5 mb-2" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "mb-0 ml-3" }
const _hoisted_28 = { key: 6 }
const _hoisted_29 = { class: "mt-5 mb-2" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "p-field-radiobutton" }
const _hoisted_32 = { for: "Fluorescent" }
const _hoisted_33 = { class: "p-field-radiobutton" }
const _hoisted_34 = { for: "Led" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "p-field-radiobutton" }
const _hoisted_37 = { for: "ActuatorSettingsOptionHalogen" }
const _hoisted_38 = { class: "p-field-radiobutton" }
const _hoisted_39 = { for: "ActuatorSettingsOptionLedTrailingEdgeOrElectronicTransformer" }
const _hoisted_40 = { class: "p-field-radiobutton" }
const _hoisted_41 = { for: "ActuatorSettingsOptionLedLeadingEdge" }
const _hoisted_42 = { class: "p-field-radiobutton" }
const _hoisted_43 = { for: "ActuatorSettingsOptionCFLTrailingEdge" }
const _hoisted_44 = { class: "p-field-radiobutton" }
const _hoisted_45 = { for: "ActuatorSettingsOptionCFLLeadingEdge" }
const _hoisted_46 = { key: 7 }
const _hoisted_47 = { class: "p-field-radiobutton" }
const _hoisted_48 = { for: "V_0_10" }
const _hoisted_49 = { class: "p-field-radiobutton" }
const _hoisted_50 = { for: "V_1_10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settings.slots, (s, index) => {
      return (_openBlock(), _createBlock("div", {
        key: `slot-${index}`,
        class: "mb-4"
      }, [
        (s.hasMoreThanOneSlotSettings)
          ? (_openBlock(), _createBlock("h6", _hoisted_2, " Slot " + _toDisplayString(index), 1))
          : _createCommentVNode("", true),
        (s.isGroupZeroCrossingVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupZeroCrossing")), 1),
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_InputSwitch, {
                  modelValue: s.isZeroCrossingEnabled,
                  "onUpdate:modelValue": ($event: any) => (s.isZeroCrossingEnabled = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsEnabled")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (s.isGroupRelayStatusAfterResetVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupRelayStatusAfterReset")), 1),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_RadioButton, {
                  id: "LastStataus",
                  name: "relayStatusAfterReset",
                  value: _ctx.RelayStatusAfterResetOptions.LastStatus,
                  modelValue: s.relayStatusAfterReset,
                  "onUpdate:modelValue": ($event: any) => (s.relayStatusAfterReset = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionLastStatus")), 1)
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_RadioButton, {
                  id: "Opened",
                  name: "relayStatusAfterReset",
                  value: _ctx.RelayStatusAfterResetOptions.Opened,
                  modelValue: s.relayStatusAfterReset,
                  "onUpdate:modelValue": ($event: any) => (s.relayStatusAfterReset = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionOpened")), 1)
              ]),
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_RadioButton, {
                  id: "Closed",
                  name: "relayStatusAfterReset",
                  value: _ctx.RelayStatusAfterResetOptions.Closed,
                  modelValue: s.relayStatusAfterReset,
                  "onUpdate:modelValue": ($event: any) => (s.relayStatusAfterReset = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionClosed")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (s.isGroupRestoreStatusAfterResetVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t(
                            "AppResource.ActuatorSettingsGroupRestoreStatusAfterReset"
                        )), 1),
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_InputSwitch, {
                  modelValue: s.isRestoreStateAfterResetEnabled,
                  "onUpdate:modelValue": ($event: any) => (s.isRestoreStateAfterResetEnabled = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsEnabled")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (s.isGroupMinimumRegulationLevelVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupMinimumRegulationLevel")), 1),
              _createVNode("div", _hoisted_21, [
                _createVNode(_component_InputSwitch, {
                  modelValue: s.isMinimumregulationLevelEnabled,
                  "onUpdate:modelValue": ($event: any) => (s.isMinimumregulationLevelEnabled = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsEnabled")), 1)
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("p", null, _toDisplayString(_ctx.$t(
                                "AppResource.ActuatorSettingsMinimumRegulationLevelPickerHeader"
                            )), 1),
                _createVNode(_component_Dropdown, {
                  modelValue: s.minimumRegulationLevelValue,
                  "onUpdate:modelValue": ($event: any) => (s.minimumRegulationLevelValue = $event),
                  options: s.minimumRegulationLevelPickerValues,
                  optionLabel: "description",
                  optionValue: "value",
                  class: "has--border",
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled"])
              ])
            ]))
          : _createCommentVNode("", true),
        (s.isGroupPULVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_24, [
              _createVNode("p", _hoisted_25, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupPUL")), 1),
              _createVNode("div", _hoisted_26, [
                _createVNode(_component_InputSwitch, {
                  modelValue: s.hasPUL,
                  "onUpdate:modelValue": ($event: any) => (s.hasPUL = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsPULEnabled")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (s.isGroupLoadTypeVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_28, [
              _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupLoadType")), 1),
              (s.hasLoadTypesForGroup7)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode(_component_RadioButton, {
                        id: "Fluorescent",
                        name: "LoadType",
                        value: _ctx.LightsLoadTypes.Fluorescent,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionFluorescent")), 1)
                    ]),
                    _createVNode("div", _hoisted_33, [
                      _createVNode(_component_RadioButton, {
                        id: "Led",
                        name: "LoadType",
                        value: _ctx.LightsLoadTypes.Led,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionLed")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (s.hasLoadTypesForGroup9)
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, [
                      _createVNode(_component_RadioButton, {
                        id: "ActuatorSettingsOptionHalogen",
                        name: "LoadType",
                        value: _ctx.LightsLoadTypes.Halogen,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionHalogen")), 1)
                    ]),
                    _createVNode("div", _hoisted_38, [
                      _createVNode(_component_RadioButton, {
                        id: "ActuatorSettingsOptionLedTrailingEdgeOrElectronicTransformer",
                        name: "LoadType",
                        value: 
                                _ctx.LightsLoadTypes.LedTrailingEdgeOrElectronicTransformer
                            ,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionLedTrailingEdgeOrElectronicTransformer")), 1)
                    ]),
                    _createVNode("div", _hoisted_40, [
                      _createVNode(_component_RadioButton, {
                        id: "ActuatorSettingsOptionLedLeadingEdge",
                        name: "LoadType",
                        value: _ctx.LightsLoadTypes.LedLeadingEdge,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionLedLeadingEdge")), 1)
                    ]),
                    _createVNode("div", _hoisted_42, [
                      _createVNode(_component_RadioButton, {
                        id: "ActuatorSettingsOptionCFLTrailingEdge",
                        name: "LoadType",
                        value: _ctx.LightsLoadTypes.CFLTrailingEdge,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionCFLTrailingEdge")), 1)
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode(_component_RadioButton, {
                        id: "ActuatorSettingsOptionCFLLeadingEdge",
                        name: "LoadType",
                        value: _ctx.LightsLoadTypes.CFLLeadingEdge,
                        modelValue: s.loadType,
                        "onUpdate:modelValue": ($event: any) => (s.loadType = $event),
                        disabled: _ctx.readonly
                      }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                      _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionCFLLeadingEdge")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (s.isGroupVoltageVisible)
          ? (_openBlock(), _createBlock("div", _hoisted_46, [
              _createVNode("p", null, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupVoltage")), 1),
              _createVNode("div", _hoisted_47, [
                _createVNode(_component_RadioButton, {
                  id: "V_0_10",
                  name: "voltageType",
                  value: _ctx.LightsVoltageOptions.V_0_10,
                  modelValue: s.voltageType,
                  "onUpdate:modelValue": ($event: any) => (s.voltageType = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionLed")), 1)
              ]),
              _createVNode("div", _hoisted_49, [
                _createVNode(_component_RadioButton, {
                  id: "V_1_10",
                  name: "voltageType",
                  value: _ctx.LightsVoltageOptions.V_1_10,
                  modelValue: s.voltageType,
                  "onUpdate:modelValue": ($event: any) => (s.voltageType = $event),
                  disabled: _ctx.readonly
                }, null, 8, ["value", "modelValue", "onUpdate:modelValue", "disabled"]),
                _createVNode("label", _hoisted_50, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsOptionLed")), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}